<template>
  <v-row class="ma-0">
    <v-col class="pa-0">
      <span class="text-truncate info-label d-inline-block" style="font-size: 10px"
        ><v-icon size="10" color="blue">mdi-information-outline</v-icon>
        {{ $translate('PRODUCT_NOT_ALWAYS_AVAILABILITY') }}</span
      >
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'ProductAvailabilityInfo',
  props: {},
  data() {
    return {};
  },
};
</script>
<style>
.info-label {
  text-overflow: ellipsis;
  overflow: hidden;
  color: rgb(29, 145, 233);
  padding: 0px 1px 1px 1px;
  font-size: 14px;
}
</style>
